import { ArrowRight } from "lucide-react";
import { usePal, FOCUS } from "./PalUI";

const PalWelcome = ({ airline, onPrimary }) => {
  const { isDark, brand, ink, muted, dim, hair } = usePal();
  const w = airline.content.welcome;
  const logo = isDark ? airline.logo : airline.logoLight || airline.logo;
  return (
    <section className="w-full" aria-labelledby="pal-welcome-title" data-testid="pal-welcome">
      <div className="mx-auto max-w-[1220px] px-6 md:px-8 lg:px-12 py-10 lg:py-14">
        <div className="flex flex-wrap items-center gap-4 mb-8">
          <div>
            <p className={`k-eyebrow ${dim}`}>{w.eyebrow}</p>
            {w.date && <p className={`mt-1.5 text-[13px] font-medium ${dim}`} data-testid="pal-welcome-date">{w.date}</p>}
          </div>
          {logo && (
            <img src={logo} alt={airline.name} className="h-6 md:h-7 w-auto" data-testid="pal-welcome-logo" />
          )}
        </div>
        <h1 id="pal-welcome-title" className={`k-h1 max-w-[18ch] ${ink}`} data-testid="welcome-headline">
          {w.headline}
          <span className="block text-[0.62em] leading-[1.1] mt-3">{w.headlineRest}</span>
          <span className="block text-[0.62em] leading-[1.1]" style={{ color: brand }}>{w.accentLine}</span>
        </h1>
        <p className={`k-lead mt-8 max-w-[58ch] ${muted}`} data-testid="welcome-subline">{w.lead}</p>

        <div className={`mt-10 pt-6 border-t max-w-[900px] ${hair}`}>
          <h2 className={`k-eyebrow ${dim}`}>{w.outcomesLabel}</h2>
          <ol className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-5">
            {w.outcomes.map((o, i) => (
              <li key={o} className="flex gap-3" data-testid={`pal-welcome-outcome-${i}`}>
                <span className="text-[13px] font-semibold tabular-nums" style={{ color: brand }}>0{i + 1}</span>
                <span className={`text-[16px] font-medium leading-snug ${ink}`}>{o}</span>
              </li>
            ))}
          </ol>
        </div>

        {onPrimary && (
          <button
            onClick={onPrimary}
            data-testid="welcome-primary"
            className={`mt-10 inline-flex items-center gap-2 h-12 px-6 rounded-full text-[15px] font-semibold transition-transform hover:scale-[1.02] ${FOCUS}`}
            style={{ backgroundColor: isDark ? "#ffffff" : "#1d1d1f", color: isDark ? "#0b0b0d" : "#ffffff" }}
          >
            {w.cta} <ArrowRight className="w-4 h-4" aria-hidden="true" />
          </button>
        )}
      </div>
    </section>
  );
};

export default PalWelcome;
